import React, { FC, memo, useMemo } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import styled from 'styled-components/native';

import { checkIsAndroid } from '@/utils/device';

const IOSText: FC<TextProps> = (props) => {
  return <BaseIOSText {...props} allowFontScaling={false} />;
};

const AndroidText: FC<TextProps> = (props) => {
  const { style } = props;

  const { fontWeight } = useMemo(() => {
    const flattenedStyle = StyleSheet.flatten(style);
    return { fontWeight: flattenedStyle?.fontWeight || 'normal' };
  }, [style]);

  if (fontWeight === '500') {
    return <BaseAndroidMediumText {...props} allowFontScaling={false} />;
  }

  return <BaseAndroidText {...props} />;
};

export default checkIsAndroid() ? memo(AndroidText) : memo(IOSText);

const BaseIOSText = styled(Text)`
  color: ${({ theme }) => theme.colors.text[0]};
  font-family: ${({ theme }) => theme.font.DEFAULT_FONT_FAMILY};
`;

const BaseAndroidText = styled(Text)`
  color: ${({ theme }) => theme.colors.text[0]};
  font-family: ${({ theme }) => theme.font.DEFAULT_ANDROID_FONT_FAMILY};
`;

const BaseAndroidMediumText = styled(Text)`
  color: ${({ theme }) => theme.colors.text[0]};
  font-family: ${({ theme }) => theme.font.DEFAULT_ANDROID_FONT_FAMILY_MEDIUM};
`;
